import React from 'react';

import { Step } from '@features/AdminConversationCategoryUpsertModal/model/types';
import { NewsletterStep } from '@features/AdminConversationCategoryUpsertModal/ui/NewsletterStep';
import { SelectStep } from '@features/AdminConversationCategoryUpsertModal/ui/SelectStep';
import { SurveyStep } from '@features/AdminConversationCategoryUpsertModal/ui/SurveyStep';
import { CustomModal } from '@shared/ui';

import cls from './AdminConversationCategoryUpsertModal.module.css';
import { useAdminConversationCategoryUpsertModal } from '../lib/hooks/useAdminConversationCategoryUpsertModal';

interface AdminConversationCategoryUpsertModalProps {
    isOpen: boolean;
    onClose: () => void;
    categoryId: number;
    formId?: number;
}

export const AdminConversationCategoryUpsertModal = ({
    onClose,
    isOpen,
    categoryId,
    formId = null,
}: AdminConversationCategoryUpsertModalProps) => {
    const { step, onChangeStep, formData } = useAdminConversationCategoryUpsertModal(
        categoryId,
        formId
    );

    const stepMapping: Record<Step, React.ReactElement> = {
        [Step.SELECT]: <SelectStep onChangeStep={onChangeStep} />,
        [Step.SURVEY]: (
            <SurveyStep
                onClose={onClose}
                categoryId={categoryId}
                formData={formData}
                formId={formId}
            />
        ),
        [Step.NEWSLETTER]: (
            <NewsletterStep
                onClose={onClose}
                categoryId={categoryId}
                formData={formData}
                formId={formId}
            />
        ),
    };

    return (
        <CustomModal contentClasses={cls.modal} isOpen={isOpen} onHideModal={onClose}>
            {stepMapping[step]}
        </CustomModal>
    );
};
